import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@app/shared/services/auth.service";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { filter, map, take } from "rxjs";

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const msalBroadcast = inject(MsalBroadcastService);
  const router = inject(Router);

  if (authService.account()) return true;

  return msalBroadcast.inProgress$.pipe(
    filter((status) => status === InteractionStatus.None),
    take(1),
    map(() =>
      authService.account() ? true : router.createUrlTree(["/login"]),
    ),
  );
};
